import { InjectionToken } from '@angular/core';
import { CategoryOrAddon } from '../../features/client-page/addon/pages/addons/addons.types';

export const categoriesAndAddons = new InjectionToken<CategoryOrAddon[]>('categoriesAndAddons');
export const filteredCategoriesAndAddons = new InjectionToken<CategoryOrAddon[]>('filteredCategoriesAndAddons');
export const inputWidth = new InjectionToken<number>('width');
